import { HgSupportedLanguage } from '@smg-real-estate/domus';

export function localizeLanguage(locale: HgSupportedLanguage): string {
  return locale === HgSupportedLanguage.EN ? locale : `${locale}-CH`;
}
